var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='\n';
 let { property_indicators, is_mobile, leadSubmitted, isLeadFormSuppressed, placeholder, shareModalTarget, virtualTourLink, realTip, propertyStatus, pageType, ab_vitality_mobile_class, hasSuppressLeadForm  } = options; 
__p+='\n\n<div class="qv-property-indicators-ab clearfix '+
((__t=( ab_vitality_mobile_class ))==null?'':__t)+
'">\n  ';
 if (placeholder) { 
__p+='\n    <div class="loading"></div>\n  ';
 } 
__p+='\n  ';
 if(property_indicators.length) { 
__p+='\n    <div class="row">\n      ';
 property_indicators.forEach((indicatorsArray) => { 
__p+='\n        <ul class="indicators col-qv-lg-4 col-qv-sm-6 col-qv-xs-12">\n            ';
 indicatorsArray.forEach((indicator) => { 
__p+='\n              <li class="col-qv-xs-12 indicator">\n                <div class="ellipsis text-right"\n                    ';
 if(indicator.key == 'Property Type' || indicator.key == 'Style' ) { 
__p+=' data-toggle="tooltip" title="'+
((__t=( indicator.value ))==null?'':__t)+
'" data-placement="top"';
 } 
__p+='>\n                  <span class="key">'+
((__t=( indicator.key ))==null?'':__t)+
'</span>\n                  <span class="font-semibold value ellipsis">'+
((__t=( indicator.value ))==null?'':__t)+
'</span>\n                </div>\n              </li>\n            ';
 }) 
__p+='\n        </ul>\n      ';
 }) 
__p+='\n  </div>\n  ';
 } 
__p+='\n</div>\n    ';
 if (!$.Device.isMobile(navigator.userAgent)) { 
__p+='\n      '+
((__t=( JST['quick_view/templates/realtip_section']({
        realTip
      }) ))==null?'':__t)+
'\n    ';
 } 
__p+='\n\n';
 if (!leadSubmitted && !isLeadFormSuppressed && hasSuppressLeadForm) { 
__p+='\n  <div class="qv-property-indicators-btn margin-top-lg margin-bottom-lg text-center">\n    <a href="javascript:void(0)" data-title="Ask a question" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':property-indicators:contact_agent" class="js-qv-contact-agent btn btn-primary margin-left-lg round-cta" data-placeholder="Ask a question">\n      Ask a question\n    </a>\n    <a href="javascript:void(0)" class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta" data-toggle="modal" data-target="'+
((__t=( shareModalTarget ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':sticky-top:share">\n      <span>Share this home</span>\n    </a>\n  </div>\n  ';
 } else { 
__p+='\n  <div class="qv-property-indicators-btn margin-top-lg margin-bottom-lg">\n    <a href="javascript:void(0)" class="js-hide-ajax-fail btn btn-default margin-left-lg round-cta" data-toggle="modal" data-target="'+
((__t=( shareModalTarget ))==null?'':__t)+
'" data-omtag="'+
((__t=( propertyStatus +':'+ pageType ))==null?'':__t)+
':sticky-top:share">\n      <span>Share this home</span>\n    </a>\n  </div>\n';
 } 
__p+='\n\n<div id="div-gpt-ad-TXTLDP3" class="ad-quick-view-preload property-badge-ads"></div>\n\n';
 if (virtualTourLink){ 
__p+='\n  <div class="font-semibold qv-mobile-virtualtour-section visible-xxs-block">\n    View <a href="'+
((__t=( virtualTourLink ))==null?'':__t)+
'" target="_blank" id="hero-view-tour" data-omtag="ldp:photogallery:virtual-tour">Virtual Tour</a> for this property\n  </div>\n';
 } 
__p+='\n';
return __p;
};



// WEBPACK FOOTER //
// ./quick_view/templates/optimization/qv-sec-property-indicators_ab.jst.ejs